export const systemUserAlias = 'System';
